import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewChatPaymentLayer from "../../components/ChatPaymentTransaction/ViewChatPaymentNew";
const ViewChatPaymentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Chat Payment" link2="/chatpayment" title="View Chat Payment" />

        {/* AddUserLayer */}
        <ViewChatPaymentLayer />


      </MasterLayout>
    </>
  );
};

export default ViewChatPaymentPage;
